/*
 * Copyright 2024 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { Button, ListItem, Menu, MenuItem } from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { useAuthProviderV1 } from "@startree-ui/platform-ui";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { AppRoute } from "../../../utils/routes/routes.util";

export const UserAccountMenu: FunctionComponent = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const { t } = useTranslation();
    const { authUser } = useAuthProviderV1();
    const history = useHistory();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (): void => {
        setAnchorEl(null);
    };

    const handleNavigateToLogout = (): void => {
        history.push(AppRoute.SIGN_OUT);
        handleClose();
    };

    return (
        <>
            <Button data-testid="app-header-account-btn" onClick={handleClick}>
                {t("label.account")}
                <AccountCircleIcon style={{ marginLeft: "8px" }} />
            </Button>
            <Menu
                keepMounted
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <ListItem data-testid="account-menu-item">
                    {authUser.email}
                </ListItem>
                <MenuItem
                    data-testid="account-menu-item"
                    onClick={handleNavigateToLogout}
                >
                    {t("label.logout")}
                    <ExitToAppIcon style={{ marginLeft: "8px" }} />
                </MenuItem>
            </Menu>
        </>
    );
};
